import { render, staticRenderFns } from "./SelectLegalForm.vue?vue&type=template&id=bcb7977a&scoped=true"
import script from "./SelectLegalForm.vue?vue&type=script&lang=js"
export * from "./SelectLegalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb7977a",
  null
  
)

export default component.exports